import React from "react";
import PredictionPage from "../../components/PredictionPage";

function UK100() {
  return (
    <PredictionPage
      title="UK100"
      content="This is the UK100 AI Trading Predictions page."
      canonical="/indices/uk100-ai-trading-predictions"
      categoryKey="nav.indices"
      categoryPath="/indices"
      symbol="UK100"
    />
  );
}

export default UK100;
